import { render, staticRenderFns } from "./workspace-members-view.vue?vue&type=template&id=6d5f90e3&scoped=true"
import script from "./workspace-members-view.vue?vue&type=script&lang=js"
export * from "./workspace-members-view.vue?vue&type=script&lang=js"
import style0 from "./workspace-members-view.vue?vue&type=style&index=0&id=6d5f90e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5f90e3",
  null
  
)

export default component.exports